const translations = {
  "en": {
    "Get your score": "Get your score"
  },
  "zh-tw": {
    "Get your score": "取得你的評分"
  }
};

export default translations;
